/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import { List } from "immutable";
import dateRange from "./dateRange";
import WalletJournal from "../records/WalletJournal";
import * as constants from "../constants/wmPayments";

function paymentList(state = new List(), action) {
  if (action.type == constants.ON_LOAD_WM_PAYMENTS_SUCCESS) {
    return new List(action.payments).map(payment => new WalletJournal(payment));
  }

  return state;
}

function paymentsSort(state = { key: "time", order: "desc" }, action) {
  if (action.type == constants.SET_WM_PAYMENTS_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

export default combineReducers({
  dateRange: dateRange(constants.SET_WM_PAYMENT_LIST_DATE_RANGE),
  paymentList,
  paymentsSort
});
